import React from 'react';
import { PlainPageHeadingContext } from 'components/plain_page_heading';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import { AppUI } from '@seedlang/state';
import TextDisplay from 'components/text_display';
import HeaderBar from 'components/header_bar';

const Wrapper = styled.div`
  width: 100%;
  padding: ${props => props.embedded ? 0 : '10px 0 0 0'};
  li {
    list-style-type: circle;
    margin: 0 0 0 50px;
  }
`;

const Content = styled.div`
  width: 100%;
  margin-top: ${props => props.embedded ? 0 : '10px'};
  background: white;
  border: ${props => props.embedded ? 0 : '1px solid #dedede'};
  border-radius: ${props => props.embedded ? 0 : '12px'};
  padding: ${props => props.embedded ? 0 : '24px'};
`;

@observer
class Privacy extends React.Component {
  static contextType = PlainPageHeadingContext;


  constructor(props) {
    super(props);
    AppUI.pageStore.getShow({ids: {pageId: 'privacy'}});
  }

  componentWillUnmount() {
    AppUI.pageStore.clearShowData();
  }

  render() {
    return (
      <Wrapper embedded={this.context}>
        <HeaderBar
          title='Privacy'
          titleRoute='privacy'
          margin='0'
        />
        {
          AppUI.pageStore.hasShowData &&
            <Content embedded={this.context}>
              <TextDisplay
                markdown={AppUI.pageStore.showData.content}
              />
            </Content>
        }
      </Wrapper>
    );
  }
}

export default Privacy;
